import { OnlineStockUI } from "./OnlineStockUI";
import { StandardProps } from "@/components/componentMap";
import {
  ensureIsActive,
  ensureIsActiveVariant,
} from "@/utils/product/ensureIsActive";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { isAvailableToPreOrder } from "@/utils/variant/isAvailableToPreOrder";
import { isInStoreOnly } from "@/utils/variant/isInStoreOnly";
import { ActiveProduct } from "@/types/types";
import { SUPPLIER_DIRECT_DMS_ID } from "@/constants/constants";

export const OnlineStock = ({
  product,
  runtimeConfig,
  configProps,
}: Pick<StandardProps, "product" | "configProps" | "runtimeConfig">) => {
  const activeProduct = ensureIsActive(product);
  const { variant, isSelected } = useVariant(product);
  const activeVariant = ensureIsActiveVariant(variant);
  const suppressVariantAttributes = !!configProps?.suppressVariantAttributes;

  if (suppressVariantAttributes) {
    return null;
  }

  if (!activeVariant || !activeProduct) {
    return null;
  }

  return (
    <OnlineStockUI
      skuId={activeVariant.aliases.skuId}
      isAvailableToOrderOrPreOrder={
        activeVariant.availability.availableToOrder ||
        isAvailableToPreOrder(activeVariant)
      }
      stockApiBaseUrl={runtimeConfig.stockApiBaseUrl}
      stockApiKey={runtimeConfig.stockApiKey}
      isInStoreOnly={isInStoreOnly(activeVariant)}
      supplierDirectMessage={getSupplierDirectMessage(activeProduct)}
      variantIsSelected={isSelected}
      isOutOfStockPreOrder={
        !activeVariant.availability.availableToOrder &&
        activeVariant.availability.unavailableReason === "outOfStock" &&
        isAvailableToPreOrder(activeVariant)
      }
    />
  );
};

function getSupplierDirectMessage(product: ActiveProduct) {
  const supplierDirectOption = product.fulfilmentOptions.available.find(
    (option) => option.aliases.dmsId === SUPPLIER_DIRECT_DMS_ID,
  );
  return supplierDirectOption?.shortDescription;
}
